<template>
  <i class="icon"
     :class="`icon--${icon} icon--${colour} icon--${size}`"
     @mouseenter="$emit('mouseenter', $event)"
     @mouseleave="$emit('mouseleave', $event)"></i>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    icon: {
      type: String,
      required: true,
    },
    colour: {
      type: String,
      required: false,
      default: 'black',
      validator: (value) => ['black', 'grey', 'dark-grey', 'white', 'primary', 'secondary', 'tertiary', 'teal', 'success', 'danger'].includes(value),
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
      validator: (value) => ['small', 'medium', 'medium-large', 'large', 'extra-large'].includes(value),
    },
  },
  computed: {
    classes() {
      const classes = []

      if (this.dark) {
        classes.push('icon--dark')
      }

      return classes.join(' ')
    },
  },
}
</script>
